(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@tableau/browser-support"), require("jquery"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["@tableau/browser-support", "jquery", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["EventUtils"] = factory(require("@tableau/browser-support"), require("jquery"), require("react"), require("react-dom"));
	else
		root["EventUtils"] = factory(root["BrowserSupport"], root["$"], root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__tableau_browser_support__, __WEBPACK_EXTERNAL_MODULE_jquery__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 